// removed by extract-text-webpack-plugin
module.exports = {"main":"Settings-main--pCF0N","fieldsetContent":"Settings-fieldsetContent--1_kwD","radioInput":"Settings-radioInput--1SlNZ","createLinks":"Settings-createLinks--yqfep"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapPanel/Settings/Settings.scss
// module id = 5R4Q
// module chunks = 4